import { render, staticRenderFns } from "./TradeReport.vue?vue&type=template&id=382f6de8"
import script from "./TradeReport.vue?vue&type=script&lang=js"
export * from "./TradeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports